import { useEffect } from "react";
import { useSelector } from "react-redux";
import { DEV_FEATURE_ACTIVATE_URL_PARAM } from "@nxplatform/helpers/common";
import { selectPendingFeaturesByName } from "@nxplatform/platform-settings/locale-setup.selectors";
import { useQuery } from "./query.hook.js";
const useFeatureChecker = (feature) => {
  const featuresFromParams = useQuery().get(DEV_FEATURE_ACTIVATE_URL_PARAM);
  useEffect(() => {
    if (featuresFromParams) {
      sessionStorage.setItem(
        DEV_FEATURE_ACTIVATE_URL_PARAM,
        JSON.stringify(featuresFromParams)
      );
    }
  }, [featuresFromParams]);
  const {
    isActive
  } = useSelector(
    (state) => {
      var _a;
      return {
        isActive: !!((_a = selectPendingFeaturesByName(state, feature)) == null ? void 0 : _a.active)
      };
    }
  );
  return {
    isActive
  };
};
export {
  useFeatureChecker
};
